import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/Kpi";
import BudgetGauge from "@/components/BudgetGauge";
import { eurShort, num } from "@/lib/format";

const fmt = (v, unita) => (unita === "pezzi" ? num(v) : eurShort(v));

/** Pallino: verde solo quando l'obiettivo e' raggiunto davvero, rosso finche' non lo e'. */
function Semaforo({ raggiunto, testId }) {
  return (
    <div className="mt-3 flex justify-center" data-testid={testId} title={raggiunto ? "Obiettivo raggiunto" : "Obiettivo non ancora raggiunto"}>
      <span className={`inline-block w-4 h-4 rounded-full ${raggiunto ? "bg-emerald-500" : "bg-red-500"}`}
        style={{ boxShadow: raggiunto ? "0 0 0 5px rgba(16,185,129,.18)" : "0 0 0 5px rgba(239,68,68,.18)" }} />
    </div>
  );
}

function Barra({ ind }) {
  const raggiunto = ind.obiettivo > 0 && ind.valore >= ind.obiettivo;
  const perc = Math.min(ind.perc ?? 0, 100);
  return (
    <Card className="px-5 py-3 h-full flex flex-col" data-testid={`mq-${ind.id}`}>
      <div className="uppercase text-xs tracking-[0.18em] font-semibold text-slate-500">{ind.titolo}</div>
      <div className="flex-1" />
      <div className="flex items-baseline justify-between mb-2">
        <span className="font-mono text-xl font-bold text-slate-900" data-testid={`mq-${ind.id}-valore`}>{fmt(ind.valore, ind.unita)}</span>
        <span className="font-mono text-xs text-slate-500">/ {fmt(ind.obiettivo, ind.unita)}</span>
      </div>
      <div className="h-3 rounded-full bg-slate-200 overflow-hidden">
        <div className={`h-full rounded-full transition-[width] duration-700 ${raggiunto ? "bg-emerald-500" : "bg-liquidato"}`}
          style={{ width: `${perc}%` }} />
      </div>
      <div className="flex-1" />
      <Semaforo raggiunto={raggiunto} testId={`mq-${ind.id}-semaforo`} />
    </Card>
  );
}

/** Sezione "Monitoraggio quarter": indicatori configurabili da Configurazioni canale corto. */
export function MonitoraggioQuarter() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/monitoraggio-quarter").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d?.indicatori?.length) return null;
  return (
    <div data-testid="monitoraggio-quarter">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-4">
        <h2 className="text-lg md:text-xl font-bold text-slate-900" data-testid="mq-titolo">{d.titolo}</h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 xl:gap-12 xl:px-8 items-stretch">
        {d.indicatori.map((ind) => ind.tipo === "tachimetro" ? (
          <BudgetGauge key={ind.id} testId={`mq-${ind.id}`} tipo="LIQUIDATO" titolo={ind.titolo}
            sottotitolo={`proiezione liquidato vs obiettivo · liquidato a oggi ${eurShort(ind.valore)}`}
            budget={ind.obiettivo} proiezione={ind.proiezione}
            scostamentoPerc={ind.perc_proiezione === null ? null : ind.perc_proiezione - 100}
            footer={<Semaforo raggiunto={ind.obiettivo > 0 && ind.valore >= ind.obiettivo} testId={`mq-${ind.id}-semaforo`} />} />
        ) : <Barra key={ind.id} ind={ind} />)}
      </div>
    </div>
  );
}
